import { X } from "lucide-react";
import { Link } from "react-router-dom";

const MobileFilterModal = ({ open, onClose, categories = [] }) => {
    return (
        <div className={`mobile-filter-modal ${open ? "open" : ""}`} style={{ top:"0"}}>
            <div className="mobile-filter-header">
                <h3>Filters</h3>
                <X size={20} onClick={onClose} />
            </div>

            <div className="mobile-filter-body">
                {categories.map((cat, idx) => (
                    <div key={idx} className="category-group pointer-crusser">
                        <Link to={`/${cat.action_url}`}>
                            <h4>{cat.name}</h4>
                        </Link>

                    </div>
                ))}
            </div>
        </div>
    );
};

export default MobileFilterModal;
